import { gql } from "gql";

export const CREATE_COMPANY_DOCUMENT_CONFIRMATION = gql(/* GraphQL */ `
  mutation CreateCompanyDocumentConfirmations(
    $documentId: ID!
    $personIds: [ID!]!
  ) {
    createCompanyDocumentConfirmations(
      documentId: $documentId
      personIds: $personIds
    )
  }
`);
